import React from 'react';

const FONT = "'Plus Jakarta Sans', sans-serif";

export default function OperationalEfficiencyPage({ parentDates } = {}) {
    return (
        <div style={{ fontFamily: FONT, textAlign: 'center', padding: '80px 20px', color: '#64748b' }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 16 }}>
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#212529', marginBottom: 8 }}>Operational Efficiency</div>
            <div style={{ fontSize: 13 }}>Coming soon — staff performance, peak hours, and scheduling insights.</div>
        </div>
    );
}
